
export const handleResponseError = (error, onError = (message) => {}) => {
  try {
    if (!error || !error.response) {
      return Promise.reject('No response');
    }
    
    const { data: { message, validationDetails } } = error.response;
    if (validationDetails && validationDetails.body && validationDetails.body.length > 0 && validationDetails.body[0].message) {
      return onError(validationDetails.body[0].message);
    }

    if (validationDetails && validationDetails.params && validationDetails.params.length > 0 && validationDetails.params[0].message) {
      return onError(validationDetails.params[0].message);
    }

    onError(message ? message : 'Something went wrong.');
    return Promise.reject(error);
  } catch (error) {
    onError('Something went wrong.');
    return Promise.reject(error);
  }
};
